import { Box, Typography, Grid } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const AVAILABLE_COLORS = [
  { key: "purple", label: "Roxo", bg: "#ede7f6", fg: "#673ab7" },
  { key: "blue", label: "Azul", bg: "#e8f0fe", fg: "#1a73e8" },
  { key: "green", label: "Verde", bg: "#e6f4ea", fg: "#34a853" },
  { key: "orange", label: "Laranja", bg: "#fef7e0", fg: "#fa7b17" },
  { key: "teal", label: "Turquesa", bg: "#e0f2f1", fg: "#009688" },
  { key: "red", label: "Vermelho", bg: "#fce8e6", fg: "#ea4335" },
  { key: "cyan", label: "Ciano", bg: "#e0f7fa", fg: "#00bcd4" },
  { key: "pink", label: "Rosa", bg: "#fce4ec", fg: "#e91e63" },
  { key: "indigo", label: "Índigo", bg: "#e8eaf6", fg: "#3f51b5" },
];

const ColorSelector = ({ value = "blue", onChange }) => {
  return (
    <Box>
      <Grid container spacing={0.75}>
        {AVAILABLE_COLORS.map(({ key, label, bg, fg }) => (
          <Grid item xs={3} sm={2} key={key}>
            <Box
              onClick={() => onChange(key)}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 1,
                border: value === key ? `2px solid ${fg}` : "1px solid #e8eaed",
                borderRadius: 1.5,
                cursor: "pointer",
                bgcolor: bg,
                transition: "border-color 0.15s, background-color 0.15s",
                position: "relative",
                "&:hover": {
                  borderColor: fg,
                },
              }}
            >
              {value === key && (
                <CheckIcon
                  sx={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    fontSize: 14,
                    color: fg,
                  }}
                />
              )}
              <Box
                sx={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  bgcolor: fg,
                  mb: 0.25,
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  fontSize: "0.625rem",
                  lineHeight: 1.2,
                  color: fg,
                  textAlign: "center",
                  fontWeight: value === key ? 600 : 400,
                }}
              >
                {label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ColorSelector;
export { AVAILABLE_COLORS };
